<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<a id="pageiii">
<h1 class="title">EXPANDING OUR NOW</h1>
<h1 class="subtitle">The Story of Open Space Technology</h1><br/><br/><br/><br/>
<h2 class="author">HARRISON OWEN</h2><br/>
<div class="image"><img alt="image" src="images/0001.jpg"/></div>
<p class="center"><span>Berrett-Koehler Publishers, Inc. San Francisco</span></p>
</a></div><a id="pageiii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?271a2230